import React, { Component } from "react";
import logo from "../images/logo-couleur.png";

class Nav extends Component {
  render() {
    const logoStyle = {
      maxWidth: "260px"
    }
    return (
      <div className="navWrapper fixed-top ">
        <div className="container">
          <nav className="navbar justify-content-between navbar-expand-lg nav-light">
            <a className="navbar-brand" href="/">
              <img style={logoStyle} src={logo} alt="Prospection"/>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div className="navbar-nav">
                <a className="nav-item nav-link" href="/strategie">
                  Stratégie
                </a>
                <a className="nav-item nav-link" href="/analyse-programmation">
                  Analyse & programmation
                </a>
                <a className="nav-item nav-link" href="/modernisation-applications">
                  Modernisation d'applications
                </a>
                <a className="nav-item nav-link active" href="/g-suite">
                  G Suite
                </a>
                <a className="nav-item nav-link" href="/contact">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

export default Nav;
